import httpUtils from '../../utils/HttpUtils'

class CodeService {

  //发送验证码
  async sendPhoneCode (phone,type) {
    console.log('发送验证码');
    var result = null;
    try {
      result = await httpUtils.post('/captcha/sms/send',{phone:phone,type:type});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //验证验证码
  async checkPhoneCode (code,type,phone) {
    console.log('验证验证码');
    var result = null;
    try {
      result = await httpUtils.post('/captcha/sms/check',{code,type,phone});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new CodeService()
